import { MSPopUpWindow } from "../popup_window/popup_window.js";
import { MSDataTree } from "../tree/tree.js";
import i18next from "i18next";
/**
 * @class ObjectTree
 * @classdesc Дерево для выбора перьев в Тренде или объектов в Журнале
 * */
export class ObjectTree {
    constructor(sel = [], type) {
        if (typeof window.customElements.get("ms-tree") === "undefined") {
            window.customElements.define("ms-tree", MSDataTree);
        }
        this._selected = sel;
        this._type = type;
        this._extendedSources = []
    }

    CreateWin(title, expandedLevel, displaynametype, pennamelevel, expanded = false, modal = false) {
        this.popup = new MSPopUpWindow();
        this.popup.dragable = true;
        this.popup.modal = modal;
        this.popup.title = title ?
            this._type === 'schedule' ?
                title :
                `${i18next.t('trend_objectTree_title')} - ${title}` :
            this._type ?
                `${i18next.t('trend_objectTree_title_obj')}` :
                `${i18next.t('trend_objectTree_title')}`;
        this.popup.height = this.Height;
        if (this.Width) this.popup.width = this.Width;
        this.popup.minimized = false;
        this.popup.mini = false;
        this.popup.closable = true;
        this.popup.resize = false;
        this.popup.boundsrestricted = true;
        this.popup.sizetocontent = 0;
        this.popup.offsetx = 0;
        this.popup.offsety = 0;
        this.popup.isenabled = true;
        this.popup.isvisible = false;
        if (!this.Width) this.popup.maxwidth = window.innerWidth - 20;
        if (this._type === 'journal') {
            this.popup.innerHTML = `<ms-tree idfield="ID" autoselect="false" horizontalalign="1" verticalalign="1" sourcetype="5" multiselect="true" expanded="${expanded}" expandedlevel="${expandedLevel}" displaynametype="${displaynametype}" displayfield="Name" proportiontype="4" style="box-sizing: border-box; display: flex; overflow: hidden; position: relative; z-index: 2; width: 100%; height: 480px; background-color: rgb(245, 240, 245);"></ms-tree><div><button style="width: 50%;height: 2em;" class="ms update">${i18next.t('apply')}</button><button style="width: 50%;height: 2em;" class="ms close">${i18next.t('cancel')}</button></div>`;
        } else if (this._type === 'schedule') {
            this.popup.innerHTML = `<ms-tree idfield="ID" autoselect="false" horizontalalign="1" verticalalign="1" sourcetype="0" valuetype="1" multiselect="false" expandedlevel="${expandedLevel}" displaynametype="${displaynametype}" displayfield="Name" proportiontype="4" style="box-sizing: border-box; display: flex; overflow: hidden; position: relative; z-index: 2; width: 100%; height: 480px; background-color: rgb(245, 240, 245);"></ms-tree><div><button style="width: 50%;height: 2em;" class="ms update">${i18next.t('apply')}</button><button style="width: 50%;height: 2em;" class="ms close">${i18next.t('cancel')}</button></div>`;
        } else {
            this.popup.innerHTML = `<ms-tree filter='{"AccessTrend":true}' idfield="ItemPath" rootidfield="ID" horizontalalign="1" verticalalign="1" sourcetype="6" multiselect="true" expanded="${expanded}" expandedlevel="${expandedLevel}" displaynametype="${displaynametype}" displayfield="Name" proportiontype="4" style="box-sizing: border-box; display: flex; overflow: hidden; position: relative; z-index: 2; width: 100%; height: 480px; background-color: rgb(245, 240, 245);"></ms-tree><div><button style="width: 50%;height: 2em;" class="ms update">${i18next.t('apply')}</button><button style="width: 50%;height: 2em;" class="ms close">${i18next.t('cancel')}</button></div>`;
        }
        this.tree = this.popup.querySelector("ms-tree");
        this.tree.pennamelevel = pennamelevel
        if (this.filter) this.tree.filtercallback = this.filter;
        if(this.rootidfield){
            this.tree.rootidfield = this.rootidfield;
        }
        this.tree.rootitem = this.rootitem;

        this.popup.querySelector(".update").onclick = (e) => {
            this.selected = this.hasTrend
                ? this.tree.objectValues :
                    this._type === 'schedule' ?
                        this.tree.value :
                        this.tree.values;
            this.popup.close();
            this._callback(this.selected);
        };

        this.popup.querySelector(".close").onclick = (e) => {
            this.popup.close();
        };

        $WinService.addWindow(this.popup);
    }

    Open(title, expandedLevel, displaynametype, pennamelevel, expanded, modal = false) {
        if (!this.popup || !this.popup.isConnected) {
            this.popup = null;
            this.CreateWin(title, expandedLevel, displaynametype, pennamelevel, expanded, modal);
        }
        if (this.hasTrend) this.tree.objectValues = this.selected;
        else if (this._type === 'schedule') this.tree.value = this.selected;
        else this.tree.values = this.selected;
        this.tree.extendedSources = this.extendedSources
        this.tree.afterInitialize();
        this.popup.isvisible = true;
        this.popup._upWindow();
    }

    get onUpdate() {
        value = this._callback;
    }
    set onUpdate(value) {
        this._callback = value;
    }

    get extendedSources() {
        return this._extendedSources
    }
    set extendedSources(value) {
        this._extendedSources = value
    }

    get selected() {
        return this._selected;
    }
    set selected(value) {
        this._selected = value;
    }

    get rootitem() {
        return this._rootitem;
    }
    set rootitem(v) {
        this._rootitem = v;
    }

    get rootidfield() {
        return this._rootidfield;
    }
    set rootidfield(v) {
        this._rootidfield = v;
    }

    /**
     * Тренд
     * @type {string}
     */
    get trend() {
        return this._trend;
    }
    set trend(value) {
        this._trend = value;
        if (typeof value !== "object") {
            let ms = this.parentElement;
            while (ms.nodeName !== "MS-WINDOW") {
                ms = ms.parentElement;
            }
            if (value) {
                if (this._trendControl)
                    this._trendControl.removeObserver(this.__reciver);

                this._trendControl = ms.querySelector(`[id="${value}"]`);

                this._trendControl.addObserver(this.__reciver);
            }
        } else {
            this._trendControl = value;
        }
    }

    get hasTrend() {
        return this._hasTrend || false;
    }

    set hasTrend(value) {
        this._hasTrend = value;
    }

    dispose() {
        this.filter = null;
        this.tree = null;
        $WinService.removeWindow(this.popup);
        this.popup = null;
    }
}
